export default "__VITE_ASSET__374054ce__"